import styled from '@emotion/styled';
import { Link } from 'components/Link/Link';

export const SLink = styled(Link)`
  color: inherit;
`;
